import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types"; // import { IconData } from '@vds/icons';

import { colors } from "@vds/theme";
import { BodyConfig, TypographyConfig } from "@vds/typography";
import { Accordion as CoreAccordion } from "@vds-core/accordions";

var Accordion = function Accordion(props) {
  var typescale = TypographyConfig && TypographyConfig.getTypescale() || "VDS";
  var bodyType = BodyConfig && BodyConfig.getStyles(typescale, "desktop", "large");

  function _calcTypography(type, viewport) {
    return bodyType;
  }

  function _calcTrigger(type, viewport) {
    return BodyConfig.getStyles(typescale, "desktop", "small");
  }

  return /*#__PURE__*/React.createElement(CoreAccordion, _extends({}, props, {
    // iconData={IconData}
    mediumIcon: true,
    colorConfig: colors,
    buttonHitArea: true,
    focusState: true,
    borderBottom: true,
    triggerHeight: 20,
    triggerSize: "medium",
    activeState: true,
    caretTrigger: true,
    caretAnimation: true,
    transitionStates: true,
    typescale: typescale,
    calcTrigger: _calcTrigger,
    calcTypography: _calcTypography,
    triggerActiveAnimation: true,
    detailPaddingTop: 8,
    linkStandalone: true,
    bodyConfig: BodyConfig
  }));
};

export default Accordion;